// actions.ts
import { SET_PRODUCTS, ProductosResponse } from './types';

export const setProducts = (products: ProductosResponse[]) => ({
    type: SET_PRODUCTS,
    payload: products
});